// Organic/Fluid theme palette - Azzurro cielo + pesca
export const ORGANIC_SKY_PEACH = {
  // Base colors - molto chiari e ariosi
  base: '#F8FBFD',
  mantle: '#F0F6F9',
  crust: '#E8F2F6',
  
  // Surface colors - toni intermedi
  surface0: '#D8E9F0',
  surface1: '#C8DFE8',
  surface2: '#B8D5E0',
  
  // Overlay colors
  overlay0: '#A0BCC8',
  overlay1: '#88A5B2',
  overlay2: '#708E9C',
  
  // Text colors
  text: '#2D4A5A',
  subtext1: '#3D5A6A',
  subtext0: '#4D6A7A',
  
  // Accent colors principali - azzurro cielo + pesca
  sky: '#A8DADC',
  skyDark: '#7AB8BB',
  skyLight: '#C8EFF0',
  
  peach: '#FFB4A2',
  peachDark: '#FF9580',
  peachLight: '#FFD4C8',
  
  // Colori complementari
  coral: '#FF9B85',
  mint: '#B8E0D2',
  sand: '#F5E6D3',
  lavender: '#D4C5E8',
  
  // Accent aggiuntivi
  rosewater: '#dc8a78',
  flamingo: '#dd7878',
  pink: '#ea76cb',
  mauve: '#8839ef',
  red: '#d20f39',
  maroon: '#e64553',
  yellow: '#df8e1d',
  green: '#40a02b',
  teal: '#179299',
  sapphire: '#209fb5',
  blue: '#1e66f5'
};

// Semantic color mappings for the app - Organic/Fluid style
export const THEME = {
  // Background
  bg: {
    primary: ORGANIC_SKY_PEACH.base,
    secondary: ORGANIC_SKY_PEACH.mantle,
    tertiary: ORGANIC_SKY_PEACH.crust,
    elevated: '#FFFFFF'
  },
  
  // Surface
  surface: {
    default: ORGANIC_SKY_PEACH.surface0,
    hover: ORGANIC_SKY_PEACH.surface1,
    active: ORGANIC_SKY_PEACH.surface2
  },
  
  // Border
  border: {
    default: ORGANIC_SKY_PEACH.surface0,
    subtle: ORGANIC_SKY_PEACH.surface1,
    emphasis: ORGANIC_SKY_PEACH.overlay0
  },
  
  // Text
  text: {
    primary: ORGANIC_SKY_PEACH.text,
    secondary: ORGANIC_SKY_PEACH.subtext0,
    tertiary: ORGANIC_SKY_PEACH.overlay1,
    inverse: '#FFFFFF'
  },
  
  // Interactive elements - azzurro cielo come primario
  primary: ORGANIC_SKY_PEACH.skyDark,
  primaryHover: ORGANIC_SKY_PEACH.sky,
  primaryLight: ORGANIC_SKY_PEACH.skyLight,
  
  // Secondary - pesca per accenti
  secondary: ORGANIC_SKY_PEACH.peach,
  secondaryHover: ORGANIC_SKY_PEACH.peachDark,
  secondaryLight: ORGANIC_SKY_PEACH.peachLight,
  
  // Chat specific
  chat: {
    userBg: ORGANIC_SKY_PEACH.skyDark,
    userBgHover: ORGANIC_SKY_PEACH.sky,
    assistantBg: '#FFFFFF',
    assistantBorder: ORGANIC_SKY_PEACH.surface0,
    loadingDot: ORGANIC_SKY_PEACH.peach,
    emptyStateBg: ORGANIC_SKY_PEACH.skyLight,
    emptyStateIcon: ORGANIC_SKY_PEACH.skyDark
  },
  
  // Node types - Catppuccin
  node: {
    problem: '#d20f39',        // ctp-red latte (dark: #f38ba8 via CSS var)
    problemFill: '#fecaca',    // soft red fill
    problemText: '#ffffff',

    solution: '#40a02b',       // ctp-green latte (dark: #a6e3a1 via CSS var)
    solutionFill: '#dcfce7',   // soft green fill
    solutionText: '#1a2e1a',

    banned: '#45475a',         // ctp-surface1
    bannedStroke: '#6c7086',   // ctp-overlay0
    bannedText: '#9399b2'      // ctp-overlay2
  },
  
  // Status colors
  success: ORGANIC_SKY_PEACH.green,
  warning: ORGANIC_SKY_PEACH.yellow,
  error: ORGANIC_SKY_PEACH.red,
  info: ORGANIC_SKY_PEACH.sky,
  
  // Canvas
  canvas: {
    bg: ORGANIC_SKY_PEACH.base,
    grid: ORGANIC_SKY_PEACH.surface1,
    connection: '#93c5fd'
  },
  
  // Selection
  selection: ORGANIC_SKY_PEACH.skyDark
};

// Color palette for color picker - tema organico
export const COLOR_PICKER_PALETTE = [
  ORGANIC_SKY_PEACH.red,
  ORGANIC_SKY_PEACH.coral,
  ORGANIC_SKY_PEACH.peach,
  ORGANIC_SKY_PEACH.sand,
  ORGANIC_SKY_PEACH.yellow,
  ORGANIC_SKY_PEACH.mint,
  ORGANIC_SKY_PEACH.green,
  ORGANIC_SKY_PEACH.teal,
  ORGANIC_SKY_PEACH.sky,
  ORGANIC_SKY_PEACH.sapphire,
  ORGANIC_SKY_PEACH.blue,
  ORGANIC_SKY_PEACH.lavender,
  ORGANIC_SKY_PEACH.pink,
  ORGANIC_SKY_PEACH.rosewater
];
